export default __webpack_public_path__ + "static/media/Roboto-Light.ce61b8b6.ttf";